module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAASElEQVQ4y2P4jwQ+MAww7wADDNgPCt7/A/x/BgWP//9/EGPQ8BigQgPO+4Nw3oDzQIz/KDE2YDwG5v9ILhtg3kDnYgRv8JR1ALsM3McMVrpJAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTE2VDE3OjE4OjExKzA5OjAwO1z6VwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyMiswOTowMD+oKM0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_00003_100x100.png
// module id = 7QfC
// module chunks = 0